export const Breakpoints = {
  // an alternative medium screen size
  md: 768,
};

export default {
  Breakpoints,
};
